<template>
  <div id="app">
    <transition :name="$route.meta.transition || 'default'">
      <router-view/>
    </transition>

  </div>
</template>

<script>
export default {
  name: 'App',
  watch: {
    '$route': function(to,from){
        // document.body.scrollTop = 0
        // document.documentElement.scrollTop = 0
      // if (to.name !== from.name) {
      //   document.body.scrollTop = 0;
      //   document.documentElement.scrollTop = 0;
      // }
    }
  }
}
</script>

<style>
#app{
  background: #141414;
}
.fade-enter-active, .fade-leave-active {
  transition: opacity 0.1s ease-in-out;
}

.fade-enter, .fade-leave-to /* .fade-leave-active 的替代 */ {
  opacity: 0.1;
}
/* 默认过渡效果 */
.default-enter-active, .default-leave-active {
  /*transition: opacity 0.1s ease;*/
}

.default-enter, .default-leave-to /* .default-leave-active 的替代 */ {
  /*opacity: 1;*/
}
.swiper-pagination{z-index: 1 !important;}
.swiper-pagination-bullet {
  background: #ffffff !important;
  opacity: 1 !important;
}
.swiper-wrapper{z-index: 2!important;}

.swiper-pagination-bullet-active {
  background: #ff6600 !important;
}
.add_button-prev-bg1{background: url("https://cyvideo.i-oranges.com/home/left1.png")center no-repeat; background-size: 100% ;}

.add_button-next-bg1{background: url("https://cyvideo.i-oranges.com/home/left1.png")center no-repeat; background-size: 100% ;}
.add_button-prev-bg{background: url("https://cyvideo.i-oranges.com/home/left.png")center no-repeat; background-size: 100% ;}
.add_button-next-bg{background: url("https://cyvideo.i-oranges.com/home/right.png")center no-repeat; background-size: 100% ;}
.add_button-prev{  left: 70px; transition: transform 0.3s ease;}
.add_button-prev,.add_button-next{width: 30px; }
.add_button-prev:after{display: none}
.add_button-next{ background: url("https://cyvideo.i-oranges.com/home/right1.png")center no-repeat; background-size: 100%; right:70px; transition: transform 0.3s ease;}
.add_button-next:after{display: none}
.add_button-next:hover{transform: scale(1.3); }
.add_button-prev:hover{transform: scale(1.3); }
</style>



// WEBPACK FOOTER //
// src/App.vue